import { render, staticRenderFns } from "./TrainingCenter.vue?vue&type=template&id=d79dd3a0&scoped=true"
import script from "./TrainingCenter.vue?vue&type=script&lang=js"
export * from "./TrainingCenter.vue?vue&type=script&lang=js"
import style0 from "./TrainingCenter.vue?vue&type=style&index=0&id=d79dd3a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d79dd3a0",
  null
  
)

export default component.exports